"use client";
import { useTina } from "@/lib/utils";

import Link from "@/components/ui/link";
import { Button } from "@/components/ui/button";

import {
  FaFacebook as FacebookIcon,
  FaInstagram as InstagramIcon,
  FaLinkedin as LinkedInIcon,
  FaYoutube as YouTubeIcon,
  FaGithub as GithubIcon,
} from "react-icons/fa";
import { FaXTwitter as XIcon } from "react-icons/fa6";

const PLATFORMS_ICONS = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  linkedin: LinkedInIcon,
  x: XIcon,
  youtube: YouTubeIcon,
  github: GithubIcon,
};

export default function Footer({ globalData }) {
  const year = new Date().getFullYear();

  const { data } = useTina({
    query: globalData.query,
    variables: globalData.variables,
    data: globalData.data,
  });

  const { socials, links } = data.global;

  return (
    <footer className="">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-4 justify-between items-center content border-t border-white/20 py-6">
        <div className="flex flex-col lg:flex-row gap-4 md:gap-6 max-md:justify-center">
          {links?.footerLinks?.map((link, index) => (
            <Button
              key={index}
              variant="link"
              asChild
              size="sm"
              // data-tina-field={tinaField(
              //   data.global.links.footerLinks[index],
              //   "link"
              // )}
            >
              <Link href={link?.link || "/"}>{link?.label}</Link>
            </Button>
          ))}
        </div>
        <div className="flex justify-center lg:justify-end gap-4">
          {socials?.socialLinks?.map((social, index) => {
            const Icon = PLATFORMS_ICONS[social?.platform?.toLowerCase()];
            return (
              <div
                key={index}
                // data-tina-field={tinaField(
                //   data.global.socials.socialLinks[index],
                //   "url"
                // )}
              >
                <a
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social?.platform}
                  className="opacity-70 hover:opacity-100 hover:text-primary-300"
                >
                  {Icon && <Icon className="w-5 h-5" />}
                </a>
              </div>
            );
          })}
        </div>

        <div className="text-xs text-foreground-500 text-center lg:text-left">
          © {year} Aberrant. All rights reserved.
        </div>
        <div className="flex flex-col sm:flex-row justify-center lg:justify-end gap-4 md:gap-6 font-light text-sm">
          {links?.footerLinksSecondary?.map((link, index) => (
            <Button
              key={index}
              variant="link"
              asChild
              size="xs"
              className="opacity-70 hover:opacity-100"
              aria-label={link?.label}
              // data-tina-field={tinaField(
              //   data.global.links.footerLinks[index],
              //   "link"
              // )}
            >
              <Link href={link?.link || "/"}>{link?.label}</Link>
            </Button>
          ))}
        </div>
      </div>
    </footer>
  );
}
